import React from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import "./setupLookAndFeel";
import reportWebVitals from "./reportWebVitals";
import "@amzn/polaris-data-grid/dist/main.css";
import router from "app/router";
import { LicenseManager } from "ag-grid-enterprise";

// Set AG Grid Enterprise license
LicenseManager.setLicenseKey(
  "Using_this_{AG_Grid}_Enterprise_key_{AG-098419}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Amazon.com_Services_LLC}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{FinTechNAM}_only_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_{FinTechNAM}_need_to_be_licensed___{FinTechNAM}_has_not_been_granted_a_Deployment_License_Add-on___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{8_May_2027}____[v3]_[01]_MTgwOTczMDgwMDAwMA==65e9671e4200bd4559238662fb1cc208"
);

const root = createRoot(document.getElementById("root")!);

root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
